import '~/components/shared/globalFooter';
import '~/components/b2c/find_care_form';
import '~/components/shared/tracking/globalTracking';
import '~/components/shared/controllers/slideOutController';
import '~/components/shared/controllers/expansionController';
import '~/components/shared/controllers/showMoreController';
import '~/components/shared/controllers/scrollToController';
import '~/components/shared/controllers/autocompleteController';
import '~/components/b2c/campaigns/tripledemic';
import '~/components/shared/navigation';

// the blog show file handles the js for the making the table dynamic and scrollable
import('~/components/consumer/modules/blog-show');
import '~/components/shared/overflowExpandableController';
